import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export abstract class LocalStorageService<T> {

  abstract readonly STORAGE_KEY: string;

  abstract set(value: T): void;

  abstract get(): T | null;

  abstract remove(): void;

  abstract clear(): void;
}
